'use client';

import { Button } from '@/components/ui/button';
import { IconArrowRight } from '@/components/ui/icons';
import { useChat } from '@ai-sdk/react';
import { promptExamples } from '@/lib/ai/promptExamples';
import { useState } from 'react';

export function EmptyScreen({ setInput }: Pick<ReturnType<typeof useChat>, 'setInput'>) {
    const [numExamplesShown, setNumExamplesShown] = useState(3);

    const handleShowAll = () => {
        setNumExamplesShown(promptExamples.length); // Show all examples when button is clicked
    };

    return (
        <div className="mx-auto max-w-2xl px-4">
            <div className="rounded-lg border bg-background p-8">
                <h1 className="mb-2 flex text-lg font-semibold text-bitly_orange">
                    Welcome to Bitly AI Chatbot!
                </h1>
                <p className="mb-2 leading-normal text-muted-foreground">
                    It can help you manage your Bitly links in a human friendly
                    way.
                </p>
                <p className="leading-normal text-muted-foreground">
                    You can start a conversation here or try the following
                    examples:
                </p>
                <div className="mt-4 flex flex-col items-start space-y-2">
                    {promptExamples
                        .slice(0, numExamplesShown)
                        .map((message, index) => (
                            <Button
                                key={index}
                                variant="link"
                                className="h-auto p-0 text-base"
                                onClick={() => setInput(message.message)}
                            >
                                <IconArrowRight className="mr-2 text-muted-foreground" />
                                {message.heading}
                            </Button>
                        ))}
                    {numExamplesShown < promptExamples.length && (
                        <Button
                            onClick={handleShowAll}
                            variant="link"
                            className="text-gray-500"
                        >
                            Show all examples
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
}

export function EmptyScreenUnAuthorized() {
    return (
        <div className="mx-auto mt-12 max-w-2xl px-4">
            <div className="rounded-lg border bg-background p-8">
                <h1 className="mb-2 flex text-lg font-semibold text-bitly_orange">
                    {/* <IconBitly className="mr-2" /> */}
                    Welcome to Bitly AI Chatbot!
                </h1>
                <p className="mb-2 leading-normal text-muted-foreground">
                    It can help you manage your Bitly links in a human friendly
                    way.
                </p>
                <p className="leading-normal text-muted-foreground">
                    You can start a conversation here or try the following
                    examples:
                </p>
                <div className="mt-4 flex flex-col items-start space-y-2">
                    {promptExamples.slice(0, 3).map((message, index) => (
                        <Button
                            key={index}
                            variant="link"
                            className="h-auto p-0 text-base"
                            disabled={true}
                        >
                            <IconArrowRight className="mr-2 text-muted-foreground" />
                            {message.heading}
                        </Button>
                    ))}
                </div>
            </div>
        </div>
    );
}
